import {Component, OnInit, ViewChild} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {ActivatedRoute, Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {LoadingBarService} from '@ngx-loading-bar/core';
import {Meta, Title} from '@angular/platform-browser';
import {GoogleAnalyticsService} from 'ngx-google-analytics';
import {DeviceDetectorService} from 'ngx-device-detector';
import {AppService} from '../../../services/app.service';
import * as $ from 'jquery';
import UIkit from 'uikit';
import {CountdownConfig} from 'ngx-countdown';

const CountdownTimeUnits: Array<[string, number]> = [
  ['Y', 1000 * 60 * 60 * 24 * 365], // years
  ['M', 1000 * 60 * 60 * 24 * 30], // months
  ['D', 1000 * 60 * 60 * 24], // days
  ['H', 1000 * 60 * 60], // hours
  ['m', 1000 * 60], // minutes
  ['s', 1000], // seconds
  ['S', 1], // million seconds
];

@Component({
  selector: 'app-live-matches',
  templateUrl: './live-matches.component.html',
  styleUrls: ['./live-matches.component.css'],
})
export class LiveMatchesComponent implements OnInit {

  public matches = [];
  public matchType = 'live';
  public currentPage = 0;
  public lastPage = 1;

  //Count Down Code
  config: CountdownConfig = {
    leftTime: 60 * 60 * 25,
    formatDate: ({date, formatStr}) => {
      let duration = Number(date || 0);

      return CountdownTimeUnits.reduce((current, [name, unit]) => {
        if (current.indexOf(name) !== -1) {
          const v = Math.floor(duration / unit);
          duration -= v * unit;
          return current.replace(new RegExp(`${name}+`, 'g'), (match: string) => {
            return v.toString().padStart(match.length, '0');
          });
        }
        return current;
      }, formatStr);
    },
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private loadingBar: LoadingBarService,
    private router: Router,
    private activatedRoue: ActivatedRoute,
    private metaService: Meta,
    private titleService: Title,
    protected $gaService: GoogleAnalyticsService,
    private deviceService: DeviceDetectorService,
    public appService: AppService
  ) {
  }

  ngOnInit(): void {
    this.getMatches();
  }

  loadMorePastMatches(): void {
    if (this.currentPage < this.lastPage) {
      this.getMatches(this.matchType, this.currentPage++);
    }
  }

  // first accordion open
  step = 0;

  setStep(index: number) {
    this.step = index;
  }

  //FAQ
  stepfaq = 0;

  setStepfaq(index: number) {
    this.stepfaq = index;
  }

  getMatches(type: string = 'live', page = 1): void {
    if (this.matchType !== type) {
      this.matches = [];
    }

    if (this.currentPage === this.lastPage) {
      $('.btn-more').hide();
    }


    this.matchType = type;
    this.loadingBar.start();
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };

    this.http.get<any>(environment.domain + '/api/prediction/lists/' + type + '/?page=' + page, httpOptions).subscribe(
      data => {
        this.loadingBar.stop();
        if (this.matches.length > 0) {
          this.matches.push(data.data.data);
        } else {
          this.matches = data.data.data;
        }
        this.currentPage = data.data.current_page;
        this.lastPage = data.data.last_page;
        // this.matches = data.data.filter(s => s.question !== null);

        console.log(this.matches);
      },
      error => {
        this.loadingBar.stop();
        console.error('There was an error!', error);
      });
  }
}
